export enum SortingOption {
  datePosted = 'Date Posted',
  startDate = 'Start Date',
  distance = 'Distance',
  applied = 'Applied'
}

export type FilterOption = {
  id: number,
  text: string
};

export type Filters = {
  availability: FilterOption[],
  basis?: FilterOption
}
